import React, {Component} from 'react';
import ToggleDisplay from 'react-toggle-display';
import Heading from './Heading';
import CalculatorForm from './CalculatorForm';
import ResultsView from './ResultsView';
import '../css/App.css';
import languageFile from '../json/language.json';
import resultsContent from '../json/results.json';
import Measure from 'react-measure';

class App extends Component {
	state = {
		config: {
			lang: this.props.lang,
			displaycta: this.props.displaycta,
			env: 'dev'
		},
		result: {
			province: '',
			heatpumptype: '',
			lowincome: ''
		},
		viewResult: false,
		submitted: false,
		dimensions: {},
		contentRect: {},
		children: {},
	};

	addResult = result => {
		this.setState({result: result}, () => {
			function customScroll(elementToScroll, scrollEnd, duration) {
				let currentTime = 0;
				const start = elementToScroll.scrollTop,
				change = (scrollEnd) - start,
				increment = 10;

				const animateScroll = function() {     
					currentTime += increment;
					const val = Math.easeInOutQuad(currentTime, start, change, duration);
					elementToScroll.scrollTop = val;

					if (currentTime < duration) {
						setTimeout(animateScroll, increment);
					}
				};

				animateScroll();
			}

			Math.easeInOutQuad = function(currentTime, startPosition, scrollDistance, scrollDuration) {
				currentTime /= scrollDuration/2;

				if (currentTime < 1) {
					return scrollDistance/2*currentTime*currentTime + startPosition;
				}

				currentTime--;

				return -scrollDistance/2 * (currentTime*(currentTime-2) - 1) + startPosition;
			};

			const edge = navigator.userAgent.match(/(Edge)/g);
			const iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
			const docElement = (edge || iOS) ? document.body : document.documentElement;

			customScroll(docElement, document.getElementById('resultstotop').offsetTop, 500);
		});
	};

	viewResult = view => {
		this.setState({viewResult: view, submitted: true});
	};

	render() {
		const view = this.state.viewResult;
		const lang = (this.state.config.lang === 'en') ? languageFile.english : languageFile.french;
		const resultContent = (this.state.config.lang === 'en') ? resultsContent.english.results : resultsContent.french.results;

		return (
			<Measure
				bounds
				onResize={(contentRect) => {
					this.setState({ dimensions: contentRect.bounds })
				}}
			>
				{ ({ measureRef }) =>
					<div ref={measureRef} id="emco-calc-app" className="emco-calc-app">
						<span id="resultstotop"></span>
						<Heading dimensions={this.state.dimensions} content={lang.heading}/>
						<div className="app__toggle-display-wrap">

							<ToggleDisplay show={!view} tag="div">
								<CalculatorForm 
									dimensions={this.state.dimensions} 
									config={this.state.config} 
									content={lang.calculator} 
									disclaimer={resultContent.disclaimer} 
									addResult={this.addResult} 
									viewResult={this.viewResult} 
									formSubmitted={this.state.submitted}
								/>
							</ToggleDisplay>

							<ToggleDisplay show={view} tag="div">
								<ResultsView
									dimensions={this.state.dimensions} 
									config={this.state.config} 
									content={resultContent} 
									result={this.state.result} 
									viewResult={this.viewResult}
								/>
							</ToggleDisplay>
						</div>
					</div>
				}
				</Measure>

		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js